var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('div',{staticClass:"app__container grey lighten-5"},[_c('header-bar'),_c('router-view',{staticClass:"app__router"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }